import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./Dashboard.module.css"; // Import the CSS Module
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { ListItemIcon } from "@mui/material";
import PaymentIcon from "@mui/icons-material/Payment";
import PendingIcon from "@mui/icons-material/Pending";
import AssignmentReturnedIcon from "@mui/icons-material/AssignmentReturned";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DraftsIcon from "@mui/icons-material/Drafts";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { useSidebarContext } from "../Sidebar/context/SidebarState";
import MakerLineChart from "../Graph/MakerGraph";
import LineChart from "../Graph/Graph";
import anime from "animejs";

const MakerDashboard = ({
  // setShowDashboard,
  showDrafts = false,
  setCurStatus = null,
  clearAllFields,
  userId,
  setFilter,
  setFetch,
}) => {
  const {
    isMoreSidebar,
    userName,

    setShowDashboard,
    showDashboard,
    sidebarText,
  } = useSidebarContext();
  const [boxes, setBoxes] = useState([]);
  console.log(boxes, "boxes");

  const baseUrl = process.env.REACT_APP_SERVER_BASE_URL;
  const [graphData2, setGraphData2] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [overAllAmount, setOverAllAmount] = useState([]);
  const [overAllAmount2, setOverAllAmount2] = useState([]);

  console.log(graphData2, 'graphData');
  

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    document.documentElement.scrollTop = 0;
    setFilter("");
    setFetch(false);
    boxes.forEach((box) => {
      if (box.statusId === 1 && !showDrafts) return;

      anime({
        targets: `#amount-${box.boxId}`, // Target specific box by ID
        innerHTML: [0, box.totalAmount], // Animate to totalAmount
        easing: "linear",
        round: 1, // Round to nearest integer
        duration: 3000,
      });
    });
  }, [boxes, showDrafts]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/get-dashboarddetailsmaker`
        );
        const newResponse = await response.data;
        console.log(newResponse, "response");
        setBoxes(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [baseUrl]);

  useEffect(() => {
    console.log(userId, 'id');
    
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/get-graphdataMaker?userId=${userId}`
        );
        console.log(response, 'res');
        
        setGraphData(response.data.response2.rows);
        setOverAllAmount(response.data.response2.overallTotalAmount);
        setGraphData2(response.data.response.rows);
        setOverAllAmount2(response.data.response.overallTotalAmount);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  console.log(graphData, "gpdata");

  const handleClick = (box) => {
    console.log(box, "boxes");
    console.log(box, "57");
    console.log(box.statusName, "58");
    if (box.boxId == 6) {
      setCurStatus("Exceeding 2 days");
    } else if (box.boxId == 5) {
      setCurStatus("");
    } else if (box.boxId == 4) {
      setCurStatus("returned");
    } else {
      setCurStatus(box.statusName);
    }
    setShowDashboard(false);
  };

  // Return the component
  return (
    <>
      <div
        style={{
          padding: "20px 20px",
          display: "flex",
          justifyContent: "space-between",
          // borderBottom: "2px solid #878787",
          alignItems: "center",
        }}
      >
        <span style={{ color: "black", fontWeight: "600", fontSize: "1rem" }}>
          Distributor Brokerage
        </span>

        <button className="add-new-btn" onClick={handleClick}>
          Add New
        </button>
      </div>
      <div className={styles.dashboardContainer}>
        <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-4">
          {boxes.map((box) => {
            if (box.statusId === 1 && !showDrafts) return null;

            return (
              <div
                className="cust-shadow border p-4 rounded-md bg-card cursor-pointer"
                onClick={() => handleClick(box)}
              >
                <p className="font-bold text-md clr-66615b leading-10 text-sm">
                  {box.title}
                </p>
                <div className="text-dark font-extrabold text-xl text-end mt-2">
                  ₹ <span id={`amount-${box.boxId}`}>0</span>
                </div>
              </div>
            );
          })}
        </div>

        <div className={styles.graphContainer}>
          <div className="cust-shadow border p-4 rounded-md bg-card">
            {graphData.length > 0 && <p>{overAllAmount}Lakhs</p>}
            <LineChart graphData={graphData} />
          </div>
          <div className="cust-shadow border p-4 rounded-md bg-card">
            {graphData2.length > 0 && <p>{overAllAmount2}Lakhs</p>}
            <MakerLineChart graphData={graphData2} />
          </div>
        </div>
      </div>
    </>
  );
};

export default MakerDashboard;
